import './bootstrap';
import '../css/app.css';

import { createApp } from 'vue'; // Import Vue 3's createApp function
import PdfToPptComponent from './Components/PdfToPptComponent.vue';

const app = createApp({
    components: {
        PdfToPptComponent

    },

});
app.mount('#app');

